<template>
    <div class="card p-3">
        <!-- <pre>{{ main_headings }}</pre> -->
        <div class="d-flex flex-row card border p-3 align-items-center">
            <div class="w-75">
                <input type="file" @change="handleFileUpload($event)" accept=".csv" name="uploadFile" id="uploadFile">
            </div>
            <div class="w-25 text-center d-flex flex-row-reverse" style="gap: 5px">
                <button class="btn btn-success" @click.prevent="saveData"><i class="fa fa-save mr-1"></i>SAVE</button>
                <a class="btn btn-success" href="https://jurysoftprojects.com/shapeNprint_api/api/uploads/sample/updatedSample.csv"><i class="fa fa-download mr-1"></i>Sample</a>
            </div>
        </div>
        <div v-if="parsed && parsed_data.length > 0" class="my-2" style="overflow-x: auto; overflow-y: auto; height: 50vh;">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th v-for="(header, index) in parsed_header" :key="index">{{ header }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(data,ind) in parsed_data">
                        <td v-for="(header, hind) in parsed_header" :key="hind">{{ data[header] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
import Swal from 'sweetalert2'
import Papa from "papaparse";
import axios from 'axios'
export default {
    data() {
        return {
            file: null,
            parsed: false,
            parsed_data: [],
            parsed_header: [],
            selected_file: null,
            main_headings: [
                'Products',
                'Designing Charges',
                'Quantity',
                'Price',
                'Delivery Date'
            ]
        }
    },
    methods: {
        async saveData() {
            if (this.parsed_data.length) {
                let category = []
                this.parsed_data.forEach(e => {
                    if (!category.find(el => el.cat_name == e['Products'])) {
                        category.push({
                            cat_name: e['Products'],
                            cat_desc: 'Default description',
                            cat_price: Number(e['Price']),
                            cat_des_price: Number(e['Designing Charges']),
                            cat_print: true,
                            cat_design: true,
                            cat_designnprint: true,
                            cat_status: true,
                        })
                    }
                })
                let options = []
                let optionValues = []
                this.parsed_header.filter(e => !this.main_headings.includes(e)).forEach(e => { 
                    if (!options.find(el => el.opt_name == e)) {
                        category.forEach(elm => {
                            if (this.parsed_data.filter(el => el.Products == elm.cat_name && el[e] && el[e] != '').length > 0) {
                                options.push({
                                    opt_name: e,
                                    cat_name: elm.cat_name
                                })
                                optionValues.push({
                                    opt_name: e,
                                    cat_name: elm.cat_name
                                })
                            }
                        })
                    }
                })
                optionValues.forEach((e, ind) => {
                    const data = []
                    this.parsed_data.forEach(el => {
                        if (!data.find(it => it.opt_val_name == el[e.opt_name]) && el.Products == e.cat_name) {
                            data.push({
                                opt_val_name: el[e.opt_name],
                                opt_val_price: Number(el['Price']),
                            })
                        }
                    })
                    optionValues[ind]['option_values'] = data
                })
                let options_combo = this.parsed_data.map(e => {
                    let data = {}
                    let combo = []
                    options.forEach(elm => {
                        // console.log(elm);
                        if (e.Products == elm.cat_name) {
                            combo.push(e[elm.opt_name])
                            data['cat_name'] = e.Products
                        }
                    })
                    data['combo'] = combo
                    data['price'] = Number(e['Price'])
                    data['quantity'] = Number(e['Quantity'])
                    data['expected_delivery_in_days'] = Number(e['Delivery Date'])
                    return data
                })
                const params = {
                    category,
                    options,
                    optionValues,
                    options_combo
                }
                const response = await axios({
                    method: 'POST',
                    url: 'https://snp-bulk.jurysoftprojects.com/bulk-upload-data',
                    data: params
                })
                Swal.fire({
                    position: 'top-end',
                    icon: response.data.status,
                    title: response.data.msg,
                    showConfirmButton: false,
                    timer: 1500
                })
                // window.location.reload()
                // this.parsed = false
                // this.parsed_data = []
                // this.parsed_header = []
                // this.selected_file = null
                // document.getElementById('uploadFile').value = null
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Please select a file.',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        },
        handleFileUpload(event) { 
            this.file = event.target.files[0];
            this.parseFile();
        },
        async parseFile() {
            Papa.parse(this.file, {
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    if (results.meta.fields.length >= this.main_headings.length && results.meta.fields.filter(e => this.main_headings.includes(e)).length == this.main_headings.length) {
                        this.parsed_data = results.data.map(e => {
                            return {
                                ...e,
                                "Designing Charges": Number(e["Designing Charges"]),
                                "price": Number(e["price"]),
                                "quantity":Number(e["quantity"]),
                            }
                        })
                        this.parsed_header = results.meta.fields
                        this.parsed = true
                    } else {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'error',
                            title: 'Use a valid csv file with proper data',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }
                }.bind(this),
            });
        },
    }
}
</script>